import { Action } from "@ngrx/store";

import { HistoryStateInfoAction, HistoryStateInfoType } from "@store/actions/historyStateInfo.action";
import { createRehydrateReducer } from "./state-persistance";
import { HistoryStateSelect } from "../models/historyStateInfo.model";

const initialState: HistoryStateSelect | null = {};

export const historyStateReducerFn = (state = initialState, action: Action): HistoryStateSelect => {
	const selectAction = action as HistoryStateInfoAction;

	switch (selectAction.type) {
		case HistoryStateInfoType.SET_HISTORY:
			return {
				...state,
				historyStateInfo: selectAction.payload
			};
		default:
			return state;
	}
};

const localStorageKey = "HistoryState";

// Create the final reducer by combining the rehydrate logic with the custom reducer function
export const historyStateInfoReducer = createRehydrateReducer<HistoryStateSelect, Action>(
	localStorageKey,
	historyStateReducerFn
);
